export default class PATH {
    dashboard = "/"
    logIn = {
        login: "/login"
    }
    forms = "/forms"
  }